export default __webpack_public_path__ + "static/media/cargo_bike_filled.a81e8cdb.svg";